import { render } from "./sweetalerts.vue?vue&type=template&id=6ba6e164"
import script from "./sweetalerts.vue?vue&type=script&lang=js"
export * from "./sweetalerts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__